/**
 * Hands a file the app already holds to the browser.
 *
 * A blob rather than a link straight to the endpoint, and now the only thing
 * that can work: the credential is an `Authorization` header this code sets,
 * not a cookie the browser attaches, so a plain anchor to a guarded endpoint
 * would arrive anonymous and be refused. It was already the right shape for a
 * second reason — a link that failed would take somebody out of the app and
 * land them on a raw error document instead of a message beside the button
 * they pressed.
 *
 * Shared because two screens export the same segment: the page listing who it
 * reaches, and the `⋯` on its row. One of them having its own copy of this is
 * one that keeps the object url alive, and a second copy of the revoke timing
 * below is the one that gets it wrong.
 */
export function downloadFile(name: string, content: string, type = 'text/csv'): void {
  const url = URL.createObjectURL(new Blob([content], { type }))
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = name
  anchor.click()
  // Released on the next tick: revoking it synchronously races the click in
  // some browsers, and the file arrives empty.
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
